/** Allowed MIME types for custom font uploads (woff2, woff, ttf, otf). */
export const ALLOWED_FONT_MIME_TYPES = [
  'font/woff2',
  'font/woff',
  'font/ttf',
  'font/otf',
];

export type FontMimeType = (typeof ALLOWED_FONT_MIME_TYPES)[number];

/**
 * Font document stored in the fonts collection (separate from assets).
 * Used for custom brand fonts uploaded to S3.
 */
export interface Font {
  id: string;
  filename: string;
  originalFilename: string;
  url?: string; // Presigned download URL when hydrated
  s3Key?: string; // Internal; not exposed in API responses
  size?: number; // Internal; not exposed in API responses
  mimeType: string;
  uploadedAt: string;
  uploadedBy: string;
  siteId: string;
}
